<template>
  <section
    class="py-16"
    :style="componentStyle"
    :id="sectionId"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="5"
          order="1"
          order-sm="0"
          class="text-center text-sm-left pt-16"
        >
          <h1
            style="font-size: 42px; padding-bottom: 33px"
            v-html="title"
          > </h1>
          <p
            style="font-size: 20px"
            v-html="text"
          ></p>
          <div
            class="btPrimary"
            align="center"
            justify="center"
          >
            <a
              class="btPrimary"
              @click.prevent="onBtnClick()"
            >{{btnText}}</a>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="7"
          order="0"
          order-sm="1"
          class="pt-0 pt-sm-16"
        >
          <v-responsive :aspect-ratio="16/9">
            <vue-plyr
              v-if="videoUrl"
              class="video-player"
            >

              <iframe
                v-if="iframe"
                :src="videoUrl"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="width: 100%;"
                width="640"
                height="360"
              >
              </iframe>
              <video
                v-else
                controls
                type="video/mp4"
                ref="video"
                :poster="videoPosterUrl"
              >
                <source :src="videoUrl" />
              </video>
            </vue-plyr>
            <v-img
              v-if="!videoUrl && imgUrl"
              :src="imgUrl"
            > </v-img>
          </v-responsive>

        </v-col>
      </v-row>
    </v-container>
  </section>

</template>
<script>
import promotionPageMixin from '../mixins/promotion-page'
import { getInternalRoute } from '../utils/routing'
export default {
  mixins: [promotionPageMixin],
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    btnText: {
      type: String
    },
    btnUrl: {
      type: String
    },
    imgUrl: {
      type: String
    },
    videoUrl: {
      type: String
    },
    videoPosterUrl: {
      type: String
    },
    videoCurrentTime: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iframe () {
      return this.videoUrl && (this.videoUrl.toLowerCase().includes('vimeo') || this.videoUrl.toLowerCase().includes('youtube'))
    },
    url () {
      return this.btnUrl ? this.btnUrl : this.ctaUrl
    }
  },
  methods: {
    onBtnClick () {
      let url = this.url
      if (url.startsWith('#')) {
          this.$scrollTo(this.url, 500, { offset: -100 }) // ~ runway menu + action bar height
      } else {
        let route = getInternalRoute(url)
        if (route) {
          this.$router.push(route)
        } else if (url) {
          window.location.href = url
        }
      }
    }
  },
  mounted () {
    if (this.$refs.video) {
      this.$refs.video.currentTime = this.videoCurrentTime
    }
  }
}
</script>
<style scoped lang="scss">
.btPrimary {
  display: block;
  margin-top: 36px;
  background-color: var(--v-secondary-base);
  height: 40px;
  width: 293px;
}

.btPrimary:hover {
  background-color: var(--v-secondary-base);
  color: white;
}

.btPrimary a {
  color: #ffffff;
  font-family: "Niveau Grotesk";
  font-size: 20px;
  letter-spacing: 0;
  padding: 5px;
}

video {
  height: auto;
  width: 100%;

  &:focus {
    outline: none;
  }
}

@media only screen and (max-width: 600px) {
  .btPrimary {
    margin: auto;
    margin-top: 20px;
  }
}
</style>

<style>
.video-player .plyr--video .plyr__controls {
  background: rgba(69, 71, 73, 0.5) !important;
  height: 45px;
  padding: 0 10px 0 10px !important;
}
.video-player .plyr__control--overlaid {
  background: rgba(69, 71, 73, 0.5) !important;
}
.video-player .plyr--full-ui input[type="range"] {
  color: rgba(125, 197, 201, 0.81) !important;
}

.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded="true"] {
  background: rgba(125, 197, 201, 0.81) !important;
}
</style>
